import { HttpService } from '@/infra/http'
import type { TCreateCadastrarClienteData, TCreateCadastrarClienteResponse } from '@/types/cliente'

export class CreateCadastrarClienteService extends HttpService {
  execute = async (cadastro: Partial<TCreateCadastrarClienteData>) => {
    return this.http.post<TCreateCadastrarClienteResponse>('api/v2/Cliente/cadastrar', cadastro)
  }
}
